import styled                 from 'styled-components';

import { TypographyVariants } from 'src/components/common/typography';

import { cssFlexColumn,
         themeColors        } from 'src/providers/theme/shared';



type DetailNoteLookAndFeel = {
  paddings: number[];
  gap: number;

  backgroundColor: string;
  borderColor: string;

  headerTypographyVariant: TypographyVariants;
  noteTypographyVariant: TypographyVariants;
}

const detailnote_light: DetailNoteLookAndFeel = {
  paddings: [20],
  gap: 6,

  backgroundColor: themeColors.PrimaryWhite,
  borderColor: themeColors.BorderPastelBluePrimary2,

  headerTypographyVariant: 'steelw400s12lh16',
  noteTypographyVariant: 'blackw400s12lh16',
}

export type DetailNoteVariants = 'light';

export const detailnote_variants: Map<DetailNoteVariants, DetailNoteLookAndFeel> = 
  new Map<DetailNoteVariants, DetailNoteLookAndFeel>([
    ['light', detailnote_light],
  ]);

export const Wrapper = styled.div<{
  lookAndFeel: DetailNoteLookAndFeel;
}>`
  width: 100%;
  position: relative;
  border: 1px solid ${(args) => args.lookAndFeel.borderColor};
  border-radius: 12px;
  background-color: ${(args) => args.lookAndFeel.backgroundColor} !important;
  padding: ${(args) => args.lookAndFeel.paddings[0]}px;
`;

export const Container = styled.div<{
  lookAndFeel: DetailNoteLookAndFeel;
}>`
  ${cssFlexColumn};
  width: 100%;
  gap: ${(args) => args.lookAndFeel.gap}px;
`
